<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="3"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="d-form" style="margin: 20px 30px">
          <table class="form-table b-table" cellspacing="0" cellpadding="0">
            <tr>
                <th width="20%">公告方</th>
                <td width="80%"> {{formDate.userName}}</td>
            </tr>
            <tr>
                <th>公告类别</th>
                <td>拍卖</td>
            </tr>
            <tr>
                <th>公告标题</th>
                <td>{{formDate.title}}</td>
            </tr>
            <tr>
                <th>客户经理姓名</th>
                <td>{{formDate.managerName}}</td>
            </tr>
            <tr>
                <th>公告正文</th>
                <td><div v-html="formDate.remark"></div></td>
            </tr>
            <tr>
                <th>认刊书</th>
                <td>
                  <div><a target="_bank" :href="formDate.authUrl.url">{{formDate.authUrl.name}}</a></div>
                </td>           
            </tr>
            <tr>
                <th>支付方式</th>
                <td>
                  <div>{{formDate.payType == 'online' ? '线上支付' : '线下支付'}}</div>
                </td>           
            </tr>
            <tr v-if="formDate.payType=='online'">
                <th>付款状态</th>
                <td>
                  <div>{{formDate.payStatus == '0' ? '待付款' : formDate.payStatus == '1'?"已付款": '等待支付结果'}}</div>
                </td>           
            </tr>
            <tr v-if="formDate.payType=='offline'">
                <th>付款凭证</th>
                <td>
                  <div><a target="_bank" :href="formDate.payUrl.url">{{formDate.payUrl.name}}</a></div>
                </td>
            </tr>
            <tr>
                <th>hash值</th>
                <td>{{formDate.hash}}</td>
            </tr>
            <tr>
                <th>存证文件</th>
                <td>
                  <div><a target="_bank" :href="formDate.fileUrl">{{formDate.fileName}}</a></div>
                </td>
            </tr>
            <tr v-if="formDate.reason">
                <th>拒绝原因</th>
                <td>{{formDate.reason}}</td>
            </tr>
          </table>
        </div>
      </el-main>
  </el-container>
</template>

<script>
import leftMenu from './components/leftMenu'
export default {
  name: "rDetail",
  components: {
    leftMenu
  },
  data() {
    return {
      id: this.$route.query.id,
      formDate:{},
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail(){
      if(this.id != ""){
        this.$api.api.getNoticePubById({id: this.id}).then(response => {
          this.formDate = response.data
          this.formDate.authUrl = JSON.parse(this.formDate.authUrl)[0]
          if(this.formDate.payType=='offline'){
            this.formDate.payUrl = JSON.parse(this.formDate.payUrl)[0]
          }
        });
      }
    }
  }
}
</script>

<style lang="less">
@import '../style.less';
.d-form .b-table{
  border-left: 1px solid #f2f2f2;
  border-top: 1px solid #f2f2f2;
  td, th {
    border-right: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 20px;
  }
}
</style>
